import { FC } from "react";

import close from "assets/images/close.svg";
import { Container, Status, StyledReactModal } from "./style";

interface DietaryModelProps {
  setIsOpen: (isOpen: boolean) => void;
  modalIsOpen: boolean;
  modalData: any;
}
const DietaryChoisePopup: FC<DietaryModelProps> = ({
  modalIsOpen,
  setIsOpen,
  modalData,
}) => {

  function closeModal() {
    setIsOpen(false);
  }
  const shownIngredients = new Set<string>();


  return (
    <StyledReactModal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Example Modal">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div className="title">
          <h3>Dietary Preference</h3>
        </div>
        <button onClick={closeModal} style={{ width: "40px" }}>
          <img src={close} alt="close" />
        </button>
      </div>
      <Container className="p-custom-scrollbar-8 custom-scrollbar">

        {/* Questions Section */}
        {modalData?.questionAndSelection?.length > 0 ? (
          <div className="top-cart">
            {modalData.questionAndSelection.map((questionItem: any, index: number) => (
              <div key={index} className="cart">
                <h2>{questionItem.question}</h2>
                <div className="dietaries">
                  {questionItem.selectedOptions.map((option: string, idx: number) => (
                    <Status key={idx}>{option}</Status>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>No question selections available.</p>
        )}

        {/* Dietary Section */}
        {modalData?.dietaries?.length > 0 ? (
          <div className="bottom-cart">
            {modalData.dietaries.map((item: any, index: number) => (
              <div key={index} className="cart">
                <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                  <img src={item.image} alt="" style={{ width: "50px", height: "50px", borderRadius: "50%" }} />
                  <h2>{item.name}</h2>
                </div>
                <div className="dietaries">
                  {item.ingredients?.length > 0 ? (
                    item.ingredients.map((ingredient: any, idx: number) => (
                      <Status key={idx}>{ingredient.name}</Status>
                    ))
                  ) : (
                    <p style={{ marginTop: "0.5rem" }}>No ingredients listed.</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>No dietaries available.</p>
        )}
      </Container>
    </StyledReactModal>
  );
};

export default DietaryChoisePopup